'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var InputWithTopLabel = require('../InputWithTopLabel/InputWithTopLabel.js');
var MaskedInput = _interopDefault(require('react-text-mask'));

var PhoneNumberInput = function (props) {
    var inputRef = props.inputRef, other = tslib.__rest(props, ["inputRef"]);
    return (React__default.createElement(MaskedInput, tslib.__assign({}, other, { ref: function (ref) {
            inputRef(ref ? ref.inputElement : null);
        }, mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/], placeholderChar: '\u2000', showMask: true })));
};
var PhoneNumberInputWithTopLabel = function (props) {
    var title = props.title, value = props.value, reporter = props.reporter, placeholder = props.placeholder, fullWidth = props.fullWidth, _a = props.error, error = _a === void 0 ? false : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.validators, validators = _c === void 0 ? [] : _c, reportErrors = props.reportErrors, activateValidation = props.activateValidation;
    return (React__default.createElement(InputWithTopLabel, { title: title, value: value, reporter: reporter, placeholder: placeholder, fullWidth: fullWidth, error: error, disabled: disabled, inputComponent: PhoneNumberInput, validators: validators, reportErrors: reportErrors, activateValidation: activateValidation }));
};

module.exports = PhoneNumberInputWithTopLabel;
